var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17.848,
    viewBox: "0 0 16 17.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 -407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83,2.9q-1.632.439-3.242.954a.54.54,0,0,0-.375.436A13.219,13.219,0,0,0,6.787,14.538,12.124,12.124,0,0,0,9.4,17.028a7.143,7.143,0,0,0,1.02.595,2.579,2.579,0,0,0,.335.131.869.869,0,0,0,.116.029.683.683,0,0,0,.115-.027,2.8,2.8,0,0,0,.335-.132,7.113,7.113,0,0,0,1.02-.595,12.133,12.133,0,0,0,2.614-2.49A13.214,13.214,0,0,0,17.531,4.289a.54.54,0,0,0-.375-.436c-.745-.238-2-.626-3.242-.954a15.291,15.291,0,0,0-3.042-.584A15.272,15.272,0,0,0,7.83,2.9Zm-.3-1.149a15.926,15.926,0,0,1,3.347-.625,15.966,15.966,0,0,1,3.347.625q1.66.446,3.3.97a1.731,1.731,0,0,1,1.194,1.409,14.414,14.414,0,0,1-2.816,11.143,13.316,13.316,0,0,1-2.877,2.737,8.26,8.26,0,0,1-1.2.7,2.472,2.472,0,0,1-.947.268,2.472,2.472,0,0,1-.947-.268,8.219,8.219,0,0,1-1.2-.7A13.317,13.317,0,0,1,5.85,15.271,14.408,14.408,0,0,1,3.033,4.128,1.73,1.73,0,0,1,4.227,2.719q1.637-.524,3.3-.97Z",
    transform: "translate(105.128 405.875)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.921,9.116a.245.245,0,0,1-.144-.046L4.806,7.641,2.834,9.07a.245.245,0,0,1-.376-.277l.769-2.277L1.234,5.149A.245.245,0,0,1,1.372,4.7H3.831l.742-2.283a.245.245,0,0,1,.466,0L5.781,4.7H8.239a.245.245,0,0,1,.139.448L6.384,6.516l.768,2.277a.245.245,0,0,1-.232.324Z",
    transform: "translate(111.194 409.069)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMake);
export default __webpack_public_path__ + "static/media/make.9aad72036fb63b544465bffd76323569.svg";
export { ForwardRef as ReactComponent };